import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "data ws_mr5" }
const _hoisted_2 = { class: "ws_drawer_footer" }

import { ref, watch, computed } from 'vue'
import type { FormInstance } from 'element-plus'
import { ElMessage } from 'element-plus'
import { CODE_ENUM } from '@/common'
import {
  addVideoInfo,
  updateVideoInfo,
  queryVideoType,
  queryVideoInfo,
} from '@/api'
import i18n from '@/i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'video-form-drawer',
  props: ['visible', 'data'],
  emits: ['update:visible', 'success'],
  setup(__props, { emit: $emit }) {

const props = __props;

const t = i18n.global.t



watch(
  () => props.visible,
  () => {
    if (props.visible) {
      queryType()
      queryDetail()
    }
  }
)

const formData = ref({
  address: '',
  appKey: '',
  appSecret: '',
  name: '',
  number: '',
  protocolPals: 'http',
  type: '',
})

const cancel = () => {
  $emit('update:visible', false)
  formRef.value.resetFields()
}

const rules: any = {
  address: [{ required: true, message: t('STATISTICS.venter') }],
  appKey: [{ required: true, message: t('STATISTICS.venter') }],
  appSecret: [{ required: true, message: t('STATISTICS.venter') }],
  name: [{ required: true, message: t('STATISTICS.venter') }],
  number: [{ required: true, message: t('STATISTICS.venter') }],
  protocolPals: [{ required: true, message: t('STATISTICS.vselect') }],
  type: [{ required: true, message: t('STATISTICS.vselect') }],
}

const loading = ref(false)
const formRef: any = ref<FormInstance>()
const handleSubmit = () => {
  formRef.value.validate(async (valid: boolean) => {
    if (valid) {
      const fn = props.data?.id ? updateVideoInfo : addVideoInfo
      loading.value = true
      const res: any = await fn({
        ...formData.value,
        id: props.data?.id,
      }).finally(() => {
        loading.value = false
      })
      if (res?.code === CODE_ENUM.SUCCESS) {
        ElMessage({
          message: res.msg,
          type: 'success',
        })
        cancel()
        $emit('success')
      }
    }
  })
}

const detailLoading = ref(false)
const queryDetail = async () => {
  const id = props.data?.id
  if (!id) {
    return
  }
  detailLoading.value = true
  const res: any = await queryVideoInfo({ id }).finally(() => {
    detailLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    const { address, appKey, appSecret, name, number, protocolPals, type } =
      res.data || {}

    formData.value = {
      address,
      appKey,
      appSecret,
      name,
      number,
      protocolPals,
      type,
    }
  }
}

const typeOps: any = ref([])
const queryType = async () => {
  const res: any = await queryVideoType()
  if (res?.code === CODE_ENUM.SUCCESS) {
    typeOps.value = res?.data
  }
}
queryType()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    "model-value": props.visible,
    title: 
      props.data.id ? _ctx.$t('STATISTICS.veditTitle') : _ctx.$t('STATISTICS.vnewTitle')
    ,
    size: "480px",
    "before-close": cancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_2, [
        _createVNode(_component_el_button, {
          loading: loading.value,
          type: "primary",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.vconfirm')), 1)
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_el_button, { onClick: cancel }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('STATISTICS.vcancel')), 1)
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          model: formData.value,
          rules: rules,
          ref_key: "formRef",
          ref: formRef,
          "label-position": "left",
          "label-width": "98"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              prop: "name",
              label: _ctx.$t('STATISTICS.vname')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  maxlength: "20",
                  placeholder: _ctx.$t('STATISTICS.vnamePla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "type",
              label: _ctx.$t('STATISTICS.vType')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  class: "ws_select_form",
                  modelValue: formData.value.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.type) = $event)),
                  placeholder: _ctx.$t('STATISTICS.vTypePla')
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeOps.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.code,
                        label: item.name,
                        value: item.code
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "protocolPals",
              label: _ctx.$t('STATISTICS.vprotocolPals')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formData.value.protocolPals,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.protocolPals) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, {
                      label: "http",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("http")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      label: "https",
                      size: "large"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("https")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "address",
              label: _ctx.$t('STATISTICS.vaddress')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.address,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.address) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('STATISTICS.vaddressPla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "appKey",
              label: _ctx.$t('STATISTICS.vkey')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.appKey,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.appKey) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('STATISTICS.vkeyPla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "appSecret",
              label: _ctx.$t('STATISTICS.vappSecret')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.appSecret,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.appSecret) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('STATISTICS.vappSecretPla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              prop: "number",
              label: _ctx.$t('STATISTICS.vnumber')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.number,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.number) = $event)),
                  maxlength: "50",
                  placeholder: _ctx.$t('STATISTICS.vnumberPla')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, detailLoading.value]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title"]))
}
}

})